import { render, staticRenderFns } from "./StbTemplate.vue?vue&type=template&id=40133e60&scoped=true"
import script from "./StbTemplate.vue?vue&type=script&lang=js"
export * from "./StbTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40133e60",
  null
  
)

export default component.exports